<header shrd-pf-ft-page-header></header>
<shrd-pf-ft-global-banner *ngIf="!isMobileApp" />

<ng-container *ngIf="!hostContext">
  <ng-container *ngIf="isStandalone; else defaultOutlet">
    <main id="main" class="hdms-main">
      <ng-container *ngTemplateOutlet="outletRef" />
    </main>
  </ng-container>
</ng-container>

<ng-template #defaultOutlet>
  <div>
    <ng-container *ngTemplateOutlet="outletRef" />
  </div>
</ng-template>

<ng-template #outletRef>
  <router-outlet
    #outlet
    shrdUicPagePreloader
    (activate)="onOutletActivate(outlet)"
    
  ></router-outlet>
  <ng-container #globalToastContainerRef />
</ng-template>

<ng-container #footerRef />
